import { OtpContext } from '@/shahrzad-assets/shared-hooks/OtpContext'
import { upgradeUserLevel } from '@/shahrzad-assets/shared-api/api'
import { errorMessage } from '@/shahrzad-assets/shared-constants/apiErrors'
import { hashCode } from '@/shahrzad-assets/shared-utils/generateHashCode'
import { useRequest } from 'ahooks'
import { message } from 'antd'
import { useContext, useMemo } from 'react'
import { useLocation, useNavigate } from 'react-router-dom'
import { sharedPathes } from '../shared-routing/pathe'
import { setReturnPath } from '../shared-constants/localstorage'

const useUpgradeUserLevel = () => {
  const { setMinutes, setSeconds, minutes, seconds, setStatus, setTraceNo } =
    useContext(OtpContext)
  const navigate = useNavigate()
  const location = useLocation()

  const nonce = useMemo(() => hashCode(), [])
  const { runAsync: fetchUpgradeUserLevel, loading: loading } = useRequest(
    upgradeUserLevel,
    {
      manual: true,
      onSuccess(data) {
        if (data?.nonce === nonce) {
          setMinutes(1)
          setSeconds(50)
          setTraceNo(data?.traceNo)
          setStatus(data?.status)
          navigate(sharedPathes.VERIFY_LEVEL2)
          setReturnPath(window.location.href)
          // window.location.href = import.meta.env.VITE_MAIN_WEB_URL + sharedPathes.VERIFY_LEVEL2
        } else {
          message.error(errorMessage.fail)
        }
      },
      onError(error: any) {
        if (error?.response?.status === 400) {
        }
      },
    },
  )

  const submitUpgradeUserLevelForm = (
    nationalCode: string,
    birthDate: string,
  ) => {
    return fetchUpgradeUserLevel({ nationalCode, birthDate, nonce: nonce })
  }

  return { fetchUpgradeUserLevel, loading, submitUpgradeUserLevelForm }
}

export default useUpgradeUserLevel
